// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  color: #333;\n  font-family: helvetica;\n  font-size: 24px;\n}\np {\n  font-size: 16px;\n}\n#root {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\nh1 {\n  text-align: center;\n  margin: 0 0 20px 0;\n}\nbutton,\nselect {\n  background: #fff;\n  border: solid #000 1px;\n  border-radius: 4px;\n  font-size: 18px;\n  padding: 4px 8px;\n  touch-action: manipulation;\n}\n", ""]);
// Exports
module.exports = exports;
